






















































import { Component, Vue } from 'vue-property-decorator';
import Panel from '@/components/Panel.vue';
import Orderbook from '@/components/Orderbook.vue';
import MyOrders from '@/components/MyOrders.vue';
import PlaceOrder from '@/components/PlaceOrder.vue';
import Console from '@/components/Console.vue';
import { StateManager } from '@/services/StateManager.ts';
import { Loader } from '@/services/Loader.ts';

@Component({
  components: {
    Panel,
    Orderbook,
    MyOrders,
    PlaceOrder,
    Console,
  },
  mounted() {
    Loader.GetInstance().LoadApp();
  },
})
export default class Dashboard extends Vue {
  private state = StateManager.GetInstance().GetState();

  get appLoaded(): boolean {
    return this.state.appLoaded;
  }

  get metamaskNotFound(): boolean {
    return this.state.metamaskNotFound;
  }
}
